export const pet_care = [
  { char: '🐾', name: 'Paw Prints', nameZh: '毛孩足跡', keywords: ['pet', 'dog', 'cat'], hot: true },
  { char: '🐱', name: 'Cat', nameZh: '貓主子', keywords: ['cat', 'pet', 'meow'], hot: true },
  { char: '🐶', name: 'Dog', nameZh: '忠實夥伴', keywords: ['dog', 'pet', 'friend'], hot: true },
  { char: '🐹', name: 'Hamster', nameZh: '倉鼠生活', keywords: ['hamster', 'small', 'cute'] },
  { char: '🦜', name: 'Parrot', nameZh: '鳥類寵物', keywords: ['bird', 'pet', 'color'] },
  { char: '🐠', name: 'Tropical Fish', nameZh: '水族養殖', keywords: ['fish', 'aquarium', 'water'] },
  { char: '🦴', name: 'Bone', nameZh: '零食獎勵', keywords: ['dog', 'food', 'treat'] },
  { char: '🧶', name: 'Yarn', nameZh: '逗貓時間', keywords: ['cat', 'play', 'toy'] },
  { char: '🚿', name: 'Shower', nameZh: '寵物美容', keywords: ['bath', 'groom', 'clean'] },
  { char: '🩺', name: 'Stethoscope', nameZh: '獸醫檢查', keywords: ['vet', 'health', 'care'] },
  { char: '🏠', name: 'House', nameZh: '寵物家居', keywords: ['home', 'bed', 'pet'] },
  { char: '🦮', name: 'Guide Dog', nameZh: '工作犬/訓練', keywords: ['train', 'pro', 'help'] },
];